import { useFetch } from '@/core/hooks/useFetch';
import { ApiResource } from '@future-harry/nxt-styles';
import { JOURNEYS_ENDPOINTS } from './journeys.endpoints';

export const getJourneys = async () => {
   const { data: journeyData } = await useFetch<ApiResource<any[]>>(JOURNEYS_ENDPOINTS.GET_ALL());

   return {
      journeyData,
   };
};
